import request from '../utils/request';


export function followExportExcel(query) {
    return request({
        url: '/sys/follow/followExportExcel',
        method: 'POST',
        dataType: "json",
        data: JSON.stringify(query),
        responseType: 'arraybuffer',
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        }
    })
}

export const pageList = (query) => {
    return request({
        url: 'sys/follow/pageList',
        method: 'POST',
        dataType: "json",
        data: JSON.stringify(query),
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        }
    });
};


/**
 * 查询回访率
 */
export const selectReturnVisitRatePage = (query) => {
    return request({
        url: 'sys/follow/selectReturnVisitRatePage',
        method: 'POST',
        dataType: "json",
        data: JSON.stringify(query),
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        }
    });
};
/**
 * 查询回访率导出
 */
export const exportReturnVisitRate = (query) => {
    return request({
        url: 'sys/follow/exportReturnVisitRate',
        method: 'POST',
        dataType: "json",
        data: JSON.stringify(query),
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        }
    });
};


